import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PopupWrapper from '../../../../components/popup/PopupWrapper';
import { getButtonClass } from '../../../../components/popup/popupUtils';

const readFileAsDataUrl = (file) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onload = () => resolve(String(reader.result || ''));
  reader.onerror = (e) => reject(e);
  reader.readAsDataURL(file);
});

const StampPopup = ({ config, onClose }) => {
  const { t } = useTranslation();
  const [stampImage, setStampImage] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');
  const formRef = useRef(null);
  const inputRef = useRef(null);

  useEffect(() => {
    setStampImage(config?.initialData?.stampImage || null);
    setErrorMessage('');
    if (inputRef.current) {
      inputRef.current.value = '';
    }
  }, [config?.initialData?.stampImage]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!stampImage) {
      setErrorMessage(t('popup.stamp.errorSelectImage'));
      return;
    }
    onClose(true, { stampImage });
  };

  const handleLeftButtonClick = () => {
    onClose(false);
  };

  const handleRightButtonClick = () => {
    const form = formRef.current;
    if (form) form.requestSubmit();
  };

  const handleFileChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    try {
      const dataUrl = await readFileAsDataUrl(file);
      setStampImage(dataUrl);
      setErrorMessage('');
    } catch (err) {
      setErrorMessage(t('popup.stamp.errorLoadImage'));
    }
  };

  return (
    <PopupWrapper
      config={config}
      onClose={onClose}
      displayType={config?.displayType || 'slide'}
      className="popup-uploader"
    >
      <div className="main-popup-body">
        <form ref={formRef} onSubmit={handleSubmit}>
          <div
            dangerouslySetInnerHTML={{
              __html: config?.content || t('popup.stamp.defaultContent'),
            }}
          />
          <div className="mt-3">
            <input
              ref={inputRef}
              type="file"
              accept="image/*"
              className="form-control"
              onChange={handleFileChange}
            />
            <div className="text-muted small mt-2">{t('popup.stamp.formatHint')}</div>
            {!!errorMessage && (
              <div className="text-danger small mt-2">{errorMessage}</div>
            )}
          </div>
          <div
            style={{
              border: '1px dashed #ced4da',
              borderRadius: '4px',
              marginTop: '16px',
              minHeight: 200,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: '#ffffff',
              padding: 12
            }}
          >
            {stampImage ? (
              <img
                src={stampImage}
                alt="stamp-preview"
                style={{ maxWidth: '100%', maxHeight: 220, objectFit: 'contain' }}
              />
            ) : (
              <div className="text-muted small">{t('popup.stamp.noPreview')}</div>
            )}
          </div>
        </form>
      </div>
      <div className="main-popup-footer d-flex justify-content-between">
        {config?.leftButton && (
          <button
            type="button"
            className={`btn main-popup-left-btn ${getButtonClass(config.leftButton.color || 'btn-secondary')}`}
            onClick={handleLeftButtonClick}
          >
            {config.leftButton.text || t('popup.common.cancel')}
          </button>
        )}
        {config?.rightButton && (
          <button
            type="button"
            className={`btn main-popup-right-btn ${getButtonClass(config.rightButton.color || 'btn-primary')}`}
            onClick={handleRightButtonClick}
          >
            {config.rightButton.text || t('popup.common.confirm')}
          </button>
        )}
      </div>
    </PopupWrapper>
  );
};

export default StampPopup;
